// AppDialog.jsx
import React from "react";
import { Dialog, DialogContent } from "@mui/material";

const AppDialog = ({
  open,
  onClose,
  children,
  maxWidth = "sm",
  fullWidth = true,
  ...props
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={{ borderRadius: "15px" }}
      {...props}
    >
      <DialogContent sx={{ borderRadius: "15px" }} className="rmui-card">
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default AppDialog;
